export default "__VITE_ASSET__gNFYMaxm__"